import { Conditionals } from "./conditionals.js";

class Landing {

    #conditionals;

    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.onDomReady();
        });

        document.addEventListener('alpine:init', () => {

            Alpine.data('range', () => ({
                value: 0
            }));
        });

        this.#conditionals = new Conditionals();
    }

    onDomReady() {
        const form = document.getElementById('form');
        this.#conditionals.init(form);
    }
}

window.landing = window.landing || new Landing();
